import { httpRequest } from "@utils/HttpRequest";
import {
    IPage,
} from "@src/types/FmsTypes";
import { IMdStoreDetail, IMdStoreFields, IMdStoreSearch } from "./StoreTypes";
import { getVrmBaseRequestUrl } from "@src/utils/constants";



class StoreService {
    async page(searchVo: IMdStoreSearch) {
        const apiUrl = "/shop/page";
        return await httpRequest.post<IPage<IMdStoreDetail>>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() });
    }
    async pageFms(searchVo: IMdStoreSearch) {
        const apiUrl = "/fms/shop/page";
        return await httpRequest.post<IPage<IMdStoreDetail>>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() });
    }
    async newPageFms(searchVo: any) {
        const apiUrl = "/fms/shop/find";
        return await httpRequest.post<IMdStoreDetail[]>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() });
    }
    async pageMd(searchVo: IMdStoreSearch) {
        const apiUrl = "/md/shop/page";
        return await httpRequest.post<IPage<IMdStoreDetail>>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() });
    }
    async find(params: IMdStoreFields) {
        const storePageUrl = "/shop/find";
        return await httpRequest.post<IMdStoreDetail[]>(storePageUrl, params, { baseURL: getVrmBaseRequestUrl() });
    }
    async one(obj: object) {
        const apiUrl = `/shop/one`;
        return await httpRequest.post<IMdStoreDetail>(apiUrl, obj, { baseURL: getVrmBaseRequestUrl() });
    }
    async insert(insertVo: any) {
        const apiUrl = "/shop/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo, { baseURL: getVrmBaseRequestUrl() });
    }
    async update(updateVo: any) {
        const apiUrl = "/shop/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo, { baseURL: getVrmBaseRequestUrl() });
    }
    //启用禁用
    async disable(params: object) {
        const apiUrl = `/shop/change`;
        return await httpRequest.post<boolean>(apiUrl, params, { baseURL: getVrmBaseRequestUrl() });
    }
    /**
 * 获取站点选择项
 * @param params 
 * @returns 
 */
    async storeDs(params: IMdStoreFields) {
        let { retData } = await this.page({ page: { pageSize: -1, pageNum: 1, } });
        const { records, ...pg } = retData;
        return records.map(el => {
            let label = ""
            if (el.name) {
                label = `${el.name}-${el.branch}`
            }
            return {
                label: label,
                value: el.code ?? ""
            }
        })
    }
}

export const storeService = new StoreService();
export default storeService
